export default __webpack_public_path__ + "static/media/mnt.d9c6d908.webp";